import { createSlice } from '@reduxjs/toolkit';
const initialValues = {
open:false,
message:'',
severity:''
}

const SnackBarStoreSlice = createSlice({
    name: 'SnackBarStore',
    initialState: initialValues,
    reducers : {
        updateSnack(state, action) {
            state.open = action.payload.open
            state.message=action.payload.message
            state.severity=action.payload.severity

        },
      
    }
})

export const SnackBarStoreAction = SnackBarStoreSlice.actions;

export default SnackBarStoreSlice.reducer;
